export default __webpack_public_path__ + "static/news6-381c04916682cedf35f14b66a1456fbb.jpeg";